import VIDEO_TYPE from "enums/VIDEO_TYPE";
import { FILE_TYPE } from "types/VideoDto";

interface VideoForFilename {
  title?: string;
  originalFilename?: string;
  type?: VIDEO_TYPE | FILE_TYPE;
}

interface ParticipantForFilename {
  firstName?: string;
  lastName?: string;
}

interface GetVideoDownloadFilenameOptions {
  index?: number;
  questionNumber?: number;
}

function sanitizeFilenamePart(value: string) {
  return value.replace(/[^a-zA-Z0-9 ]/g, "").trim();
}

export function getFileExtensionFromOriginalKey(
  originalFilename: string | undefined,
) {
  if (!originalFilename) return "mp4";
  const withoutQuery = originalFilename.split("?")[0] ?? originalFilename;
  const parts = withoutQuery.split(".");
  if (parts.length < 2) return "mp4";
  return parts.pop()!.toLowerCase();
}

export default function getVideoDownloadFilename(
  video: VideoForFilename | undefined,
  participant: ParticipantForFilename | undefined,
  options?: GetVideoDownloadFilenameOptions,
) {
  const title = sanitizeFilenamePart(video?.title || "") || "video";
  const firstName = participant?.firstName
    ? sanitizeFilenamePart(participant.firstName)
    : "";
  const lastInitial = participant?.lastName?.charAt(0) || "";
  const questionNumber = options?.questionNumber
    ? `Q${options.questionNumber}`
    : "";
  const prefix = [firstName, lastInitial, questionNumber]
    .filter(Boolean)
    .join("_");
  const clipSuffix = video?.type === VIDEO_TYPE.CLIP ? "[CLIP]" : "";
  const extension = getFileExtensionFromOriginalKey(video?.originalFilename);
  const indexPrefix = options?.index != null ? `${options.index}_` : "";
  const nameBody = prefix ? `${prefix}_${title}` : title;

  return `${indexPrefix}${nameBody}${clipSuffix}.${extension}`;
}
